import { reactQueryMutationAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

import { invalidationCacheKeys } from "./constants";
import type { ApprovalSettingParams, ApprovalSettingResponse } from "./types";

export const postAppsApprovalSettings = reactQueryMutationAdapter(
  invalidationCacheKeys,
  async (params: ApprovalSettingParams): Promise<ApprovalSettingResponse> => {
    return await fetch("/apps/approval_settings", "POST", params);
  }
);
